import React from 'react';
interface User{
  isSignedIn?: boolean;
}
export const User = (
  {isSignedIn = false }:User
) => {
  return (
    <div className="flex pr-2 relative" style={{ top: isSignedIn ? 0:-6 }}>
      <div className={` h-full relative text-primary-bright-blue ${isSignedIn ? "border-2 rounded-full p-2":""}`} style={{borderColor: "rgb(0, 87, 255)"}}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M11.9998 1.5C8.27187 1.5 5.24979 4.52208 5.24979 8.25C5.24979 10.7006 6.55565 12.8457 8.50956 14.0283C4.68451 15.1853 1.94379 18.0555 0.810341 20.7051C0.647648 21.0857 0.8235 21.5264 1.2039 21.6895C1.58463 21.8523 2.02527 21.6755 2.18827 21.2949C3.44853 18.3486 7.0912 15.0002 12.0965 15C17.0374 15.0001 20.3314 17.9582 21.6795 20.9873L21.8035 21.2803L21.8357 21.3506C22.0128 21.6868 22.42 21.8414 22.7801 21.6963C23.1402 21.5511 23.3263 21.1571 23.2205 20.792L23.1951 20.7197L23.0506 20.3809C21.84 17.6605 19.2862 15.0168 15.5799 13.9707C17.483 12.7771 18.7498 10.6622 18.7498 8.25C18.7498 4.52221 15.7275 1.50022 11.9998 1.5ZM11.9998 3C14.8991 3.00022 17.2498 5.35064 17.2498 8.25C17.2498 11.1494 14.8991 13.4998 11.9998 13.5C9.1003 13.5 6.74979 11.1495 6.74979 8.25C6.74979 5.35051 9.1003 3 11.9998 3Z" fill="#0057FF"/>
        </svg>
      </div>
    </div>
  );
};

